import { render, staticRenderFns } from "./PermissionsCard.vue?vue&type=template&id=01d247f6"
import script from "./PermissionsCard.vue?vue&type=script&lang=js"
export * from "./PermissionsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports